import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => Promise.reject(err),
);

export const TIER_LABELS = {
    free: "Free",
    pro: "Pro",
    sports_premium: "Sports Premium",
};

export const ALLOWED_REACTIONS = ["\ud83d\udd25", "\ud83d\udcaf", "\ud83c\udfaf", "\u26a1", "\ud83e\udd1d", "\ud83d\udc80", "\ud83e\udd11"];
